import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Table as SemanticTable,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const ContainerApproval = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 520px;
`;

export const Table = styled(SemanticTable)`
  &&& {
    margin: 0px;
    padding: 0px;
    width: 100%;
    color: inherit;
  }
`;

export const Row = styled(SemanticTable.Row)``;

export const Column = styled(SemanticTable.Cell)`
  word-break: break-all;
`;

export const Header = styled(SemanticTable.Header)``;

export const HeaderCell = styled(SemanticTable.HeaderCell)`
  &&&& {
    font-weight: 500;
    color: #4D5473;
    font-size: 14px;
  }
`;

export const Body = styled(SemanticTable.Body)``;

export const Description = styled(TextLayoutComponent)`
  width: 520px;
  margin-bottom: 5px;
  ${({ textAlign }) => textAlign && `
    text-align: center;
  `}
`;

export const TextEmail = styled(TextLayoutComponent)`
  display: flex;
  font-size: 16px;
  width: 400px;
  max-width: 760px;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)``;

export const Link = styled.a`
  margin-left: 20px;
  width: 80px;
`;

export const LinkDanger = styled.a`
  color: #ED3A4E;
  margin-left: 20px;
  margin-right: 20px;

  :hover {
    color: #ED3A4E;
  }

  :active {
    color: #ED3A4E;
  }
`;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.dropdown {
    min-width: 100px;
    width: auto;
  }
  &&& {
    &&:hover {
      background: ${({ theme }) => theme.color.white};

    }
    &.active {
      background: ${({ theme }) => theme.color.white};
    }
  }
`;
